import { constants } from '../constants';
import {
  AustraliaStatesList,
  PayloadContent,
  StatesList,
} from '../models';

interface StructureDate {
  value: string;
  code: string;
  concatenatedCode: string;
}

export const validContentResponse = (state: any, action: any) => {
  const { payload } = action;
  if (payload.status !== constants.MICROSERVICE_RESPONSE_STATUS.SUCCESSFUL_REQUEST) {
    return Object.assign({}, state, {
      loadingPDetailContent: false,
      error: action.payload,
    });
  }
  return null;
};

export const mapResourceList = (
  payload: PayloadContent
) => {
  const genderMap = toArray(payload.Gender);
  const tempStateOnlyList: any = sortArrayByName(
    toArray(payload.StatesOnlyList).map(({ type, name }) => {
      return {
        code: type,
        name,
      } as StatesList;
    })
  );

  const statesOnlyList = [
    tempStateOnlyList[32],
    ...tempStateOnlyList.filter((state: any, index: number) => index !== 32),
  ];

  const stateList: StatesList[] = toArray(payload.StateList).map(
    ({ type, name }) => {
      return {
        code: type,
        name,
        canadianProvince: !statesOnlyList.find(
          (usState: any) => usState.code === type
        ),
      } as StatesList;
    }
  );

  const australiaDriverLicenseStateList: AustraliaStatesList[] = sortArrayByName(toArray(payload.AustraliaDriverLicense).map(
    ({ type, name }) => {
      return {
        code: type,
        name
      };
    }));

  const orderedStateList = [
    stateList[26],
    ...sortArrayByName(stateList.filter((state, index) => index !== 26)),
  ];

  const countryDTOs = sortArrayByName(toArray(payload.CountryList)).map(
    (country: any) => {
      return {
        countryName: country.name,
        countryCode: country.type,
      };
    }
  );

  const docTypeMap = Object.keys(payload.TravelDocuments)
    .sort((a: string, b: string) => { return a.localeCompare(b) })
    .reduce((accumulator: any, key: string) => {
      accumulator[key.toUpperCase()] = payload.TravelDocuments[key];
      return accumulator;
    }, {});

  const months = toArray(payload.Months).map((month) => {
    return {
      code: month.type,
      value: month.name,
      concatenatedCode: `${month.type}~~${month.name}`,
    } as StructureDate;
  });

  return {
    statesList: orderedStateList,
    statesOnlyList,
    genderMap,
    australiaDriverLicenseStateMap: australiaDriverLicenseStateList,
    enhancedDriverLicenseStateMap: payload.EnhancedDriverLicense,
    countryDTOs,
    docTypeMap,
    months,
    years: generateYears(),
    days: generateDays(),
  };
};

export const generateYears = () => {
  const yearsArray: StructureDate[] = [];
  const startYear = 1900;
  const endYear = new Date().getFullYear();

  for (let year = startYear; year <= endYear; year += 1) {
    const yearOption: StructureDate = {
      value: year.toString(),
      code: year.toString(),
      concatenatedCode: `${year}~~${year}`,
    };
    yearsArray.push(yearOption);
  }

  return yearsArray;
};

export const generateDays = () => {
  const daysArray: StructureDate[] = [];

  for (let i = 1; i <= 31; i += 1) {
    const dayValue = i.toString().padStart(2, '0');
    const dayOption: StructureDate = {
      value: i.toString(),
      code: dayValue,
      concatenatedCode: `${dayValue}~~${i}`,
    };
    daysArray.push(dayOption);
  }

  return daysArray;
};

const sortArrayByName = (array: any) => {
  return array.sort((propertyA: any, propertyB: any) => {
    if (propertyA.name < propertyB.name) {
      return -1;
    }
    return propertyA.name > propertyB.name ? 1 : 0;
  });
};

const toArray = (input: any): { type: string; name: string }[] => {
  return Object.keys(input).map(function (key) {
    return { type: key, name: input[key] };
  });
};
